export default __webpack_public_path__ + "static/media/liyue.30968239.png";